import {CLIENT_VERSION} from 'version'
import {ga4} from './ga4'

type Data = {[key: string]: unknown}

const getErrorMessage = (error: unknown) => {
  return error instanceof Error ? error.message : String(error)
}

const addTrackingError = (message: string, data?: Data) => {
  try {
    ga4({
      event: 'tracking_error',
      tracking: {
        message,
        client_version: CLIENT_VERSION,
        ...data,
      },
    })
  } catch (error) {
    console.error(error)
  }
}

export const addTrackingException = (error: unknown, data?: Data) => {
  addTrackingError(getErrorMessage(error), data)
}

export default addTrackingError
